import { Module } from 'vuex';

import { entryFlowStatsService } from '@/services/entry-flow-stats/entry-flow-stats.service';
import { EntryFlowStatsDetail, EntryFlowStatsSummaryRow } from '@/services/entry-flow-stats/entry-flow-stats.types';
import { RootState } from '@/store';

export interface EntryFlowStatsState {
  entryFlowStats: EntryFlowStatsSummaryRow;
  entryFlowStatsDetail: EntryFlowStatsDetail;
  entryFlowStatsDetailLoading: boolean;
}

const state: EntryFlowStatsState = {
  entryFlowStats: null,
  entryFlowStatsDetail: null,
  entryFlowStatsDetailLoading: false
};

const options: Module<EntryFlowStatsState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    setEntryFlowStats: ({ commit, dispatch }, row: EntryFlowStatsSummaryRow | number | string): Promise<void> => {
      if (row === null || row === undefined) {
        commit('entryFlowStats', null);
        commit('entryFlowStatsDetail', null);
        return Promise.resolve();
      }
      if (typeof row === 'number' || typeof row === 'string') {
        return dispatch('getEntryFlowStatsDetail', row);
      }
      commit('entryFlowStats', row);
      return dispatch('getEntryFlowStatsDetail', row.purchase_id);
    },
    getEntryFlowStatsDetail: ({ commit, dispatch }, purchaseId: number): Promise<void> => {
      commit('entryFlowStatsDetailLoading', true);

      return entryFlowStatsService
        .get(purchaseId)
        .then(detail => detail && commit('entryFlowStatsDetail', detail))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('entryFlowStatsDetailLoading', false));
    },
    clearEntryFlowStats: ({ dispatch }): Promise<void> => {
      return dispatch('setEntryFlowStats', null);
    }
  },
  mutations: {
    entryFlowStats: (state, row: EntryFlowStatsSummaryRow) => (state.entryFlowStats = row),
    entryFlowStatsDetail: (state, detail: EntryFlowStatsDetail) => (state.entryFlowStatsDetail = detail),
    entryFlowStatsDetailLoading: (state, loading: boolean) => (state.entryFlowStatsDetailLoading = loading)
  }
};

export default options;
